import { useMemo, useState } from "react";
import Reveal from "@/components/feature/Reveal";
import { materialFilters, materials } from "@/mocks/homeData";

export default function MaterialLibrary() {
  const [active, setActive] = useState("all");

  const visible = useMemo(
    () => (active === "all" ? materials : materials.filter((item) => item.type === active)),
    [active],
  );

  return (
    <section id="library" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <Reveal className="max-w-2xl">
          <p className="font-label text-xs md:text-sm tracking-[0.24em] text-primary-600">材料库</p>
          <h2 className="mt-4 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            一份一份翻，别只看截图里的那一句
          </h2>
          <p className="mt-4 font-body text-sm md:text-base leading-7 text-foreground-600">
            每份材料都标出来源与获取时间，先看整理说明，再决定要不要展开原始内容。
          </p>
        </Reveal>

        <Reveal delay={80}>
          <div className="inline-flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-50 p-1">
            {materialFilters.map((filter) => (
              <button
                key={filter.id}
                type="button"
                onClick={() => setActive(filter.id)}
                className={`rounded-full px-4 py-2 font-label text-sm cursor-pointer transition-colors whitespace-nowrap ${
                  active === filter.id
                    ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        {visible.map((item, index) => (
          <Reveal key={item.id} as="article" delay={(index % 4) * 50}>
            <div className="group flex flex-col h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors">
              <div className="flex items-center justify-between gap-4">
                <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                  <i className={`${item.icon} text-sm`} aria-hidden="true"></i>
                  {item.typeLabel}
                </span>
                <span className="font-label text-xs text-foreground-500">{item.event}</span>
              </div>

              <h3 className="mt-4 font-heading font-bold text-base md:text-lg leading-snug text-foreground-950">
                {item.title}
              </h3>

              <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs md:text-sm text-foreground-600 flex-1">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-archive-line text-base" aria-hidden="true"></i>
                  {item.source}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-stack-line text-base" aria-hidden="true"></i>
                  {item.size}
                </span>
              </div>

              <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between gap-4">
                <span className="font-label text-xs text-foreground-500">获取于 {item.time}</span>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 rounded-md bg-foreground-950 px-4 py-2.5 font-label text-sm text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-download-2-line text-base" aria-hidden="true"></i>
                  查看原始
                </button>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={60}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 rounded-lg border border-background-200 bg-background-50 px-6 py-6">
          <p className="font-body text-sm text-foreground-600">
            当前为 <strong className="font-heading font-bold text-foreground-950">{visible.length}</strong> 份材料，
            完整库共 3,985 份，按事件编号随时取用。
          </p>
          <button
            type="button"
            className="inline-flex items-center gap-2 rounded-md border border-primary-300 px-5 py-2.5 font-label text-sm text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-more-line text-base" aria-hidden="true"></i>
            载入更多材料
          </button>
        </div>
      </Reveal>
    </section>
  );
}